/** @jsxImportSource react */
import { useState } from 'react'
import { Alert, Box, Button, Paper, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { unsubscribeAPI } from '../api/crm'
import { getErrorMessage } from '../utils/apiErrors'

/** Where an email's unsubscribe link lands (no sign-in): confirm, done. */
const UnsubscribePage = () => {
  const { token } = useParams()
  const { data, error, isLoading } = useQuery({ queryKey: ['unsubscribe', token], queryFn: () => unsubscribeAPI.info(token), retry: false })
  const [done, setDone] = useState(false)
  const [failed, setFailed] = useState('')
  const confirm = () => unsubscribeAPI.confirm(token).then(() => setDone(true)).catch((e) => setFailed(getErrorMessage(e)))
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default', p: 2 }}>
      <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, maxWidth: 440, width: '100%', textAlign: 'center' }}>
        {isLoading && <Typography color="text.secondary">One moment…</Typography>}
        {error && <Alert severity="error">This unsubscribe link isn’t valid. It may have been copied incompletely.</Alert>}
        {data && (done || data.unsubscribed ? (
          <>
            <Typography variant="h6" sx={{ mb: 1 }}>You’re unsubscribed</Typography>
            <Typography color="text.secondary">{data.email} won’t get bulk emails from {data.workspace} any more.</Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" sx={{ mb: 1 }}>Unsubscribe?</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>Stop bulk emails from {data.workspace} to {data.email}.</Typography>
            {failed && <Alert severity="error" sx={{ mb: 2 }}>{failed}</Alert>}
            <Button variant="contained" onClick={confirm}>Unsubscribe</Button>
          </>
        ))}
      </Paper>
    </Box>
  )
}

export default UnsubscribePage
